import { render, staticRenderFns } from "./RetailRegister.vue?vue&type=template&id=5fe22a89&scoped=true&lang=pug"
import script from "./RetailRegister.vue?vue&type=script&lang=js"
export * from "./RetailRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe22a89",
  null
  
)

export default component.exports